import React from 'react';
import { MapBackground, SearchBar, DebugOverlay, MapOverlay } from './components';
import { LayerController } from './components/LayerController';
import { useMapStore } from './store/useMapStore';
import { useLayerRestore } from './hooks/useLayerRestore';

export const MapPage: React.FC = () => {
  const overlayOpen = useMapStore(state => state.overlayOpen);
  const overlayType = useMapStore(state => state.overlayType);
  const overlayData = useMapStore(state => state.overlayData);
  const overlayCounter = useMapStore(state => state.overlayCounter);
  const closeOverlay = useMapStore(state => state.closeOverlay);
  const { isRestoring } = useLayerRestore();

  const handleSearch = (query: string) => {
    console.log('Searching for:', query);
    // Implement geocoding logic here
  };

  return (
    <div style={{ position: 'relative', width: '100%', height: '100vh' }}>
      <MapBackground />
      <SearchBar onSearch={handleSearch} />
      <LayerController />
      {isRestoring && (
        <div style={{
          position: 'absolute',
          top: 12,
          left: '50%',
          transform: 'translateX(-50%)',
          background: 'rgba(0, 0, 0, 0.75)',
          color: '#fff',
          padding: '8px 16px',
          borderRadius: 6,
          fontSize: 13,
          zIndex: 1000,
          pointerEvents: 'none',
        }}>
          Restoring layers…
        </div>
      )}
      {process.env.REACT_APP_SHOW_DEBUG === 'true' && <DebugOverlay />}
      <MapOverlay
        key={overlayCounter}
        isOpen={overlayOpen}
        onClose={closeOverlay}
        overlayType={overlayType}
        data={overlayData}
      />
    </div>
  );
};
